import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';

/*
 * The icon set has no sharp-cornered triangle, so the trend markers are drawn here. Both share the
 * same 9.09x7.73 triangle centred in a 16x16 box, mirrored vertically, and fill with `currentColor`
 * so the caller sets the colour through `className`.
 */
const TrendTriangleUpIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M3.4545 11.8636 8 4.1364l4.5455 7.7272H3.4545Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg aria-hidden="true" fill="none" focusable="false" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const TrendTriangleDownIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M3.4545 4.1364h9.091L8 11.8636 3.4545 4.1364Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg aria-hidden="true" fill="none" focusable="false" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export { TrendTriangleDownIcon, TrendTriangleUpIcon };